export default "/images/3875c6c85f45995c46a59f2410b9b73c.jpg";